<template>
  <collection-hub />
</template>

<script>
import CollectionHub from '@/components/CollectionHub.vue'

export default {
  name: 'CollectionHubView',
  components: { CollectionHub },
}
</script>
